import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Typography,
  useTheme,
  useMediaQuery,
  TextField as MuiTextField,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import Parse from "parse";

export const Reports = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  const currentUserData = localStorage.getItem(
    `Parse/${process.env.REACT_APP_APP_ID}/currentUser`
  );
  if (!currentUserData) navigate("/login");

  const [gameData, setGameData] = useState([]);
  const [txnData, setTxnData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [error, setError] = useState("");

  const fetchReportData = async () => {
    try {
      setLoading(true);
      setError("");

      const [gameRes, txnRes] = await Promise.all([
        Parse.Cloud.run("getAgentGameCoinsReport", {
          startDate: startDate || undefined,
          endDate: endDate || undefined,
        }),
        Parse.Cloud.run("getAgentTransactionsSummary", {
          startDate: startDate || undefined,
          endDate: endDate || undefined,
        }),
      ]);

      console.log(txnRes,"txnRestxnRes")
      setGameData(gameRes?.data || []);
      setTxnData(txnRes || []);
    } catch (err) {
      console.error("Fetch error:", err);
      setError("Failed to load report data.");
      setGameData([]);
      setTxnData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReportData();
  }, []);

  const handleApplyFilters = () => {
    fetchReportData();
  };

  // Game Coins totals
  const totalBet = gameData.reduce((sum, r) => sum + (r.totalBetAmount || 0), 0);
  const totalWin = gameData.reduce((sum, r) => sum + (r.totalWinAmount || 0), 0);
  const netGameIncome = totalBet - totalWin;
  const rtp = totalBet > 0 ? ((totalWin / totalBet) * 100).toFixed(2) : "0.00";

  // Transactions totals
  const totalRecharge = txnData.recharges || 0;
  const totalRedeem = txnData.redeems || 0;
  const netRecharge = totalRecharge - totalRedeem;
  const rechargeCount = txnData.rechargeCount || 0;
  const redeemCount = txnData.redeemCount || 0;
  const earn = totalRecharge -totalRedeem || 0
  return (
    <React.Fragment>
      {/* Date Filter */}
      <Box display="flex" gap={2} flexWrap="wrap" sx={{ mt: 5, mb: 2 }}>
        <MuiTextField
          label="Start Date"
          type="date"
          size="small"
          InputLabelProps={{ shrink: true }}
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />
        <MuiTextField
          label="End Date"
          type="date"
          size="small"
          InputLabelProps={{ shrink: true }}
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />
        <Button
          variant="contained"
          onClick={handleApplyFilters}
          sx={{
            background: "#FFC107",
            color: "#0A0A0A",
            textTransform: "none",
          }}
          disabled={loading}
        >
          {loading ? "Loading..." : "Apply Filters"}
        </Button>
      </Box>

      {error && (
        <Typography color="error" sx={{ mb: 2 }}>
          {error}
        </Typography>
      )}

      {loading ? (
        <Box display="flex" justifyContent="center" py={4}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper} sx={{ mt: 2, background: "#1c1c1c" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell colSpan={8}>
                  <Typography variant="h6" color="white">
                     Summary
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell><strong>Total Bet Amount</strong></TableCell>
                <TableCell><strong>Total Win Amount</strong></TableCell>
                <TableCell><strong>Game Net Income</strong></TableCell>
                <TableCell><strong>RTP (%)</strong></TableCell>
                <TableCell><strong>Total Recharges</strong></TableCell>
                <TableCell><strong>Total Redeems</strong></TableCell>
                <TableCell><strong>Total income</strong></TableCell>
                {/* <TableCell><strong>Recharge Net</strong></TableCell> */}
                {/* <TableCell><strong>Recharge/Redeem Counts</strong></TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>{totalBet.toFixed(2)}</TableCell>
                <TableCell>{totalWin.toFixed(2)}</TableCell>
                <TableCell>{netGameIncome.toFixed(2)}</TableCell>
                <TableCell>{rtp}%</TableCell>
                <TableCell>{totalRecharge.toFixed(2)}</TableCell>
                <TableCell>{totalRedeem.toFixed(2)}</TableCell>
                <TableCell>{earn.toFixed(2)}</TableCell>

                {/* <TableCell>${netRecharge.toFixed(2)}</TableCell> */}
                {/* <TableCell>
                  {rechargeCount} / {redeemCount}
                </TableCell> */}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </React.Fragment>
  );
};
